
import { defineComponent, ref, reactive } from "vue";
import { modifyState, reseditRes, resgetParRes, resAddres, resupdate } from "@/api/Menuconfiguration";
import { ElMessage } from "element-plus";
import type { FormInstance, FormRules } from "element-plus";
import { useRouter, useRoute } from "vue-router";
export default defineComponent({
  setup() {
    const router = useRouter();
    const route = useRoute();
    const tableData = ref<any>();
    const tableColumn = ref([
      {
        prop: "resourceName",
        label: "菜单名称",
      },
      {
        slotName: "accounttype",
      },
      {
        slotName: "Sort",
      },

      {
        slotName: "slotName",
      },
    ]);
    const ruleFormRef = ref<FormInstance>();
    const modelrules = reactive<FormRules>({
      resourceName: [{ required: true, message: "请输入菜单名称", trigger: "blur" }],
    });
    const SearchClass = () => {
      getzhtTable();
    };
    const FromData = ref<any>({
      preResourceNo: Number(route.query.id),
      resourceIoc: "",
      resourceName: "",
      resourceSys: "01",
      resourceUrl: "213",
    });
    const imageUrl = ref("");
    const delectImg = (val: string) => {
      imageUrl.value = val;
    };
    const changeImg = (val: any) => {
      console.log(val, "上传图片");
      imageUrl.value = val.fileUrl;
    };
    const zhtText = ref<any>();
    const zhtData = ref<any>({
      preResourceNo: route.query.id,
    });
    const getzhtTable = () => {
      resgetParRes(zhtData.value).then((res) => {
        console.log(res);
        tableData.value = res.data;
        tableData.value.forEach((item: any) => {
          if (!item.sort) {
            item.sort = 0;
          }
        });
      });
    };
    getzhtTable();

    const textTitle = ref<any>();
    const GooldData = ref<any>({
      command: "",
      merchantId: 0,
      resourceNo: 0,
    });
    // 主后台推送开关
    const pushDisplay = ref<boolean>(false);
    const switchFn = (row: any) => {
      console.log(row);
      GooldData.value.merchantId = row.merchantId;
      GooldData.value.resourceNo = row.resourceNo;
      zhtText.value = "启用推送后，商户端将自动接收该分类数据，并且不可逆，确认要继续吗";

      gooleshow.value = true;
    };
    const zhtpushDisplay = () => {
      pushDisplay.value = false;
      getzhtTable();
    };
    const zhtClick = () => {
      pushDisplay.value = false;
      gooleshow.value = true;
    };
    // 谷歌
    const gooleshow = ref(false);
    // 谷歌确认
    const onconfirm = (val: any) => {
      console.log(val.ruleForm.gooleId);
      GooldData.value.command = val.ruleForm.gooleId;
      modifyState(GooldData.value).then((res) => {
        if (res.code == 1) {
          ElMessage.success(res.msg as string);
          gooleshow.value = false;
          getzhtTable();
        } else {
          ElMessage.error(res.msg as string);
          gooleshow.value = false;
        }
      });
    };

    // 排序
    const paixudispaly = ref(false);
    const formpaixu = ref<any>();
    const zhtinputnumber = (row: any) => {
      console.log(row);
      paixudispaly.value = true;
      formpaixu.value = row;
    };
    const qurenpaixudispaly = () => {
      reseditRes(formpaixu.value).then((res) => {
        console.log(res);
        if (res.code == 1) {
          ElMessage.success(res.msg as string);
          getzhtTable();
        } else {
          ElMessage.error(res.msg as string);
        }
      });
      paixudispaly.value = false;
    };
    const qxpaixudispaly = () => {
      paixudispaly.value = false;
      getzhtTable();
    };
    // 主后台菜单编辑添加

    const EditmenuDisplay = ref<boolean>(false);
    const edit = (row: any) => {
      console.log(row);
      textTitle.value = "编辑";
      EditmenuDisplay.value = true;
      imageUrl.value = row.resourceIoc;
      FromData.value.resourceName = row.resourceName;
      FromData.value.resourceNo = row.resourceNo;
      FromData.value.resourceSys = row.resourceSys;
      FromData.value.resourceUrl = row.resourceUrl;
      FromData.value.isActive = row.isActive;
      AddEd.value = "Ed";
    };
    // 编辑确认 +  添加二级菜单
    const saveEdit = async (formEl: FormInstance | undefined) => {
      if (!formEl) return;
      await formEl.validate((valid, fields) => {
        if (valid) {
          if (AddEd.value == "add") {
            FromData.value.resourceIoc = imageUrl.value;
            resAddres(FromData.value).then((res) => {
              if (res.code == 1) {
                ElMessage.success(res.msg as string);
                getzhtTable();
                EditmenuDisplay.value = false;
              } else {
                ElMessage.error(res.msg as string);
              }
            });
          } else {
            FromData.value.resourceIoc = imageUrl.value;
            resupdate(FromData.value).then((res) => {
              if (res.code == 1) {
                ElMessage.success(res.msg as string);
                getzhtTable();
                EditmenuDisplay.value = false;
              } else {
                ElMessage.error(res.msg as string);
              }
            });
          }
        }
      });
    };

    const AddEd = ref<any>();
    // 添加二级菜单
    const addSelectone = () => {
      textTitle.value = "添加二级菜单";
      EditmenuDisplay.value = true;
      FromData.value.resourceUrl = "";
      FromData.value.resourceName = "";
      FromData.value.resourceIoc = "";
      imageUrl.value = "";
      delete FromData.value.resourceNo;
      AddEd.value = "add";
    };

    //跳转二级
    const goTow = (row: any) => {
      console.log(row);
      router.push({ path: "/Merchantmenu/zht/zhtthree", query: { id: row.resourceNo } });
    };
    const onClose = () => {
      // console.log(1);
      getzhtTable();
    };
    return {
      tableData,
      onClose,
      tableColumn,
      switchFn,
      pushDisplay,
      EditmenuDisplay,
      edit,
      FromData,
      zhtData,
      SearchClass,
      zhtpushDisplay,
      textTitle,
      zhtText,
      zhtinputnumber,
      saveEdit,
      addSelectone,
      goTow,
      zhtClick,
      onconfirm,
      gooleshow,
      delectImg,
      changeImg,
      imageUrl,
      qurenpaixudispaly,
      paixudispaly,
      qxpaixudispaly,
      ruleFormRef,
      modelrules,
    };
  },
});
